import { render, staticRenderFns } from "./raise-foreign-visits.vue?vue&type=template&id=63636c62"
import script from "./raise-foreign-visits.vue?vue&type=script&lang=ts"
export * from "./raise-foreign-visits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports